import graphql from 'babel-plugin-relay/macro';

/**
 * Mutations
 */
export const AUTH_COMPLETE_SETUP_MUTATION = graphql`
  mutation authCompleteSetupMutation($input: CompleteSetupInput!) {
    completeSetup(input: $input)
  }
`;

export const AUTH_UPDATE_USER_PASSWORD_MUTATION = graphql`
  mutation authUpdateUserProfilePasswordMutation($id: ID!, $input: UpdateUserProfilePassword!) {
    updateUserProfilePassword(id: $id, input: $input)
  }
`;

export const AUTH_GOOGLE_COMPLETE_OAUTH = graphql`
  mutation authGoogleCompleteOauthMutation($code: String!) {
    googleCompleteOauth(code: $code) {
      ...userProfileBaseFragment
    }
  }
`;

export const AUTH_HANDLE_VERIFY_EMAIL_MUTATION = graphql`
  mutation authHandleVerifyUserEmailMutation($input: HandleVerifyUserEmailInput!) {
    handleVerifyUserEmail(input: $input)
  }
`;

export const AUTH_VALIDATE_VERIFY_USER_EMAIL_QUERY = graphql`
  query authValidateVerifyUserEmailQuery($input: ValidateVerifyUserEmailInput!, $skip: Boolean!) {
    validateVerifyUserEmail(input: $input) @skip(if: $skip) {
      email
      countryId
      practitionerType
    }
  }
`;
